import { useState } from "react";
import CurrencyInput from "react-currency-input-field";
import { DECIMAL_INTL_CONFIG } from "./decimalInputConfig";

const toDraftValue = (value) => {
    if (value === null || value === undefined || value === "") {
        return undefined;
    }
    return String(value).replace(".", ",");
};

export default function PPDecimalInput({
    value,
    onValueChange,
    onBlur,
    onFocus,
    defaultValue: _defaultValue,
    ...rest
}) {
    const [isEditing, setIsEditing] = useState(false);
    const [draft, setDraft] = useState(undefined);

    const valueProps = isEditing
        ? (draft !== undefined ? { value: draft } : {})
        : { value: value === "" ? undefined : value };

    return (
        <CurrencyInput
            {...rest}
            {...valueProps}
            intlConfig={DECIMAL_INTL_CONFIG}
            decimalSeparator=","
            disableGroupSeparators
            onValueChange={(stringValue, name, values) => {
                if (isEditing) {
                    setDraft(stringValue);
                }
                onValueChange?.(stringValue, name, values);
            }}
            onFocus={(event) => {
                if (!isEditing) {
                    setIsEditing(true);
                    setDraft(toDraftValue(value));
                }
                onFocus?.(event);
            }}
            onBlur={(event) => {
                setIsEditing(false);
                setDraft(undefined);
                onBlur?.(event);
            }}
        />
    );
}
